import React, { forwardRef, useContext } from 'react';
import DiscoveryContextV2 from '../../../contexts/discoveryContext/contextV2';

const WithSearchInfo = (ChildComponent) =>
  forwardRef((props, ref) => {
    const { queryParams, pushHistory, filters } = useContext(
      DiscoveryContextV2,
    );

    return (
      <ChildComponent
        searchParams={{ ...queryParams() }}
        updateSearchQueryString={pushHistory}
        contextFilters={filters}
        ref={ref}
        {...props}
      />
    );
  });

export default WithSearchInfo;
